import React from 'react';
// logic
import { useHistory } from 'react-router-dom';
// icons
import ToolbarContainer from 'modules/emergencies/components/ui/containers/toolbarContainer';
import ToolBarButton from 'modules/emergencies/components/ui/toolbar/toolBarButton';
import ToolbarTitle from 'modules/emergencies/components/ui/toolbar/toolbarTitle';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
// components

const EditCarrierUserPageToolbar = ({ carrierId }) => {
  const history = useHistory();

  return (
    <ToolbarContainer noPaddingX>
      <ToolbarTitle>Edit user</ToolbarTitle>
      <ToolBarButton
        onClick={() => {
          history.push(`/carrier/${carrierId}/edit/`);
        }}
      >
        <CloseIcon />
      </ToolBarButton>
    </ToolbarContainer>
  );
};

export default EditCarrierUserPageToolbar;
